module.exports = __webpack_public_path__ + "img/Poorter_hotel-452.b637085e.jpg";